import { httpClient } from "@/services";

export default {
	actions: {
		async getDataUser() {
			try {
				const { data } = await httpClient.post('/user');
				return data;
			} catch (error) {
				return await error;
			}
		}
	}
};
